export function checkFileSize(
  files: File[],
  maxSize: number
): {
  acceptedFiles: File[];
  tooLargeFiles: File[];
} {
  const acceptedFiles: File[] = [];
  const tooLargeFiles: File[] = [];
  files.forEach((file) => {
    if (file.size > maxSize * 1024 * 1024) {
      tooLargeFiles.push(file);
    } else {
      acceptedFiles.push(file);
    }
  });
  return { acceptedFiles, tooLargeFiles };
}

export function checkFileType(
  files: File[],
  acceptedFileExtensions: FileExtension[]
): {
  accepetedFiles: File[];
  disallowedFiles: File[];
} {
  const accepetedFiles: File[] = [];
  const disallowedFiles: File[] = [];
  const acceptedFileTypes = acceptedFileExtensions.map(extensionToMimeType);
  files.forEach((file) => {
    const fileType = file.type as MimeType;
    const fileExtension = getFileExtension(file.name);
    if (
      acceptedFileTypes.includes(fileType) ||
      (fileExtension !== null && acceptedFileExtensions.includes(fileExtension))
    ) {
      accepetedFiles.push(file);
    } else {
      disallowedFiles.push(file);
    }
  });
  return { accepetedFiles, disallowedFiles };
}

export type MimeType =
  | 'application/msword'
  | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  | 'application/vnd.ms-excel'
  | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  | 'application/vnd.ms-powerpoint'
  | 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  | 'application/pdf'
  | 'image/avif'
  | 'image/png'
  | 'image/jpeg'
  | 'image/heif'
  | 'image/heic'
  | 'image/svg+xml'
  | 'application/json'
  | 'text/xml'
  | 'text/csv'
  | 'text/plain'
  | 'video/mp4'
  | 'video/quicktime';

export const supportedFileExtensions = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.heic',
  '.heif',
  '.json',
] as const;

export type FileExtension = (typeof supportedFileExtensions)[number];

export function extensionToMimeType(fileExtension: FileExtension): MimeType {
  const fileTypes: Record<FileExtension, MimeType> = {
    '.pdf': 'application/pdf',
    '.png': 'image/png',
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.heic': 'image/heic',
    '.heif': 'image/heif',
    '.json': 'application/json',
  };

  return fileTypes[fileExtension];
}

function getFileExtension(filename: string): FileExtension | null {
  const dotIndex = filename.lastIndexOf('.');
  if (dotIndex < 0) return null;

  const extension = filename.slice(dotIndex).toLowerCase();
  return supportedFileExtensions.includes(extension as FileExtension)
    ? (extension as FileExtension)
    : null;
}
